import React from 'react'
import { NavLink, Outlet } from 'react-router-dom'

const tabs = [
  { to: '/admin/users',    label: 'Users' },
  { to: '/admin/stores',   label: 'Stores' },
  { to: '/admin/products', label: 'Products' },
]

const AdminLayout: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <h2 className="text-2xl font-bold text-stone-100">Admin</h2>

      <div className="flex gap-1 border-b border-army-800">
        {tabs.map(({ to, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${
                isActive
                  ? 'text-neon border-b-2 border-neon -mb-px bg-navy-900'
                  : 'text-gray-500 hover:text-stone-300'
              }`
            }
          >
            {label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  )
}

export default AdminLayout
